import { ArrowUpRight, Sparkles, Play } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/398462f9-c697-4d36-a7a9-a2cb1d14b6b1/images/02f14a8d0248cf330cfa9f12d9d0ff8ac974b64c61b2dd2127ca995e121a6cce.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/40 via-[#050505]/65 to-[#050505]" />
        <div className="absolute inset-0 ring-grid opacity-40" />
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#007AFF]/30 blur-[140px]" />
        <div className="absolute -bottom-40 right-0 h-[400px] w-[400px] rounded-full bg-[#00F0FF]/15 blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-40 md:pt-44 pb-20 md:pb-24">
        <div className="grid grid-cols-12 gap-6 md:gap-8 items-end">
          <div className="col-span-12 lg:col-span-9">
            {/* Eyebrow */}
            <div
              data-testid="hero-eyebrow"
              className="reveal inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass text-xs font-semibold tracking-[0.18em] uppercase text-[#00F0FF]"
            >
              <Sparkles className="h-3.5 w-3.5" />
              UK-based · Premium Tech Consultancy
            </div>

            {/* Headline */}
            <h1
              data-testid="hero-headline"
              className="reveal mt-7 font-display font-black leading-[0.88] tracking-[-0.04em] text-balance text-[clamp(3rem,9vw,7.25rem)]"
            >
              Build Smarter.
              <br />
              <span className="text-gradient-blue">Grow Faster.</span>
            </h1>

            {/* Sub */}
            <p
              data-testid="hero-subheadline"
              className="reveal mt-7 max-w-2xl text-slate-300 text-lg sm:text-xl leading-relaxed"
            >
              Websites, business systems, and marketing engines —
              engineered to scale ambitious UK companies. One partner.
              Zero compromises.
            </p>

            {/* CTAs */}
            <div className="reveal mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="group inline-flex items-center gap-2 pl-7 pr-2 py-2 rounded-full bg-[#007AFF] text-white font-semibold hover:bg-[#00F0FF] hover:text-black transition-all duration-300 animate-pulse-glow"
              >
                Book a free consultation
                <span className="grid place-items-center h-10 w-10 rounded-full bg-black text-white group-hover:bg-white group-hover:text-black transition-colors">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </a>
              <a
                href="#clients"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full border border-white/15 text-white/90 hover:bg-white/5 transition-colors"
              >
                <span className="grid place-items-center h-7 w-7 rounded-full bg-white/10">
                  <Play className="h-3 w-3 fill-white" />
                </span>
                See our clients
              </a>
            </div>
          </div>

          {/* Stats stack */}
          <div className="col-span-12 lg:col-span-3 lg:justify-self-end w-full">
            <div
              data-testid="hero-stats"
              className="reveal grid grid-cols-3 lg:grid-cols-1 gap-3"
            >
              {[
                { k: "120+", v: "Projects shipped" },
                { k: "4.9★", v: "Client average" },
                { k: "38%", v: "Avg. revenue lift" },
              ].map((s) => (
                <div
                  key={s.v}
                  className="glass rounded-2xl px-5 py-4"
                >
                  <div className="font-display text-3xl font-extrabold tracking-tight">
                    {s.k}
                  </div>
                  <div className="text-xs text-slate-400 mt-1">{s.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 inset-x-0 h-32 bg-gradient-to-b from-transparent to-[#050505]" />
    </section>
  );
}
